var map = {
	"./data-search.de-CH.json": 919,
	"./data-search.de-DE.json": 920,
	"./data-search.en-CA.json": 921,
	"./data-search.en-GB.json": 922,
	"./data-search.en-IN.json": 923,
	"./data-search.en-ME.json": 924,
	"./data-search.en-US.json": 925,
	"./data-search.es-EM.json": 926,
	"./data-search.es-ES.json": 927,
	"./data-search.fr-BE.json": 928,
	"./data-search.fr-CA.json": 929,
	"./data-search.fr-CH.json": 930,
	"./data-search.nl-BE.json": 931,
	"./data-search.nl-NL.json": 932,
	"./data-search.pl-PL.json": 933,
	"./data-search.pt-BR.json": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 918;